import React from 'react'
import ProjectAccordianItem from '../ProjectAccordianItem';
import { ProjectList } from '../../common/interface';

import "./style.scss"
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

interface ProjectHierarchyProps {
    filteredProject: ProjectList[];
    handleProjectSelection: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, project: ProjectList) => void;
}

const ProjectHierarchy: React.FC<ProjectHierarchyProps> = ({ filteredProject, handleProjectSelection }) => {
    const projectState = useSelector((state: RootState) => state.project);
    const selectedProject = projectState.selectedProject;
    return (
        <div className="project_wrapper">
            {filteredProject.map((project, index) => (
                <ProjectAccordianItem
                    key={index}
                    project={project}
                    level={0}
                    selectedProject={selectedProject}
                    handleProjectSelection={handleProjectSelection}
                />
            ))}
        </div>
    );
};

export default ProjectHierarchy
